import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { getAccessToken } from "../auth/keycloak";
import { BASE_API_URL } from "./_api-config";


const rawBaseQuery = fetchBaseQuery({
  baseUrl: BASE_API_URL,
});

const baseQueryWithKeycloak: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const request: FetchArgs =
    typeof args === "string" ? { url: args } : { ...args };

  const token = await getAccessToken();

  const headers = new Headers();

  if (request.headers instanceof Headers) {
    request.headers.forEach((value, key) => {
      headers.set(key, value);
    });
  } else if (Array.isArray(request.headers)) {
    for (const entry of request.headers) {
      if (entry.length >= 2) {
        const [key, value] = entry;
        if (typeof key === "string" && typeof value === "string") {
          headers.set(key, value);
        }
      }
    }
  } else if (request.headers) {
    for (const [key, value] of Object.entries(request.headers)) {
      if (typeof value === "string") {
        headers.set(key, value);
      }
    }
  }

  headers.set("authorization", `Bearer ${token}`);
  request.headers = headers;

  return rawBaseQuery(request, api, extraOptions);
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithKeycloak,
  tagTypes: ["Session", "SessionMessages"],
  endpoints: () => ({}),
});